var map = {
	"./BG login.jpeg": 22193,
	"./GO-Express-Foto-Perfil.png": 45853,
	"./GO-Express-icone-2.jpg": 39343,
	"./GO-Express-icone-2.png": 91396,
	"./GO-Express-icone.jpg": 49445,
	"./GO-Express-icone.png": 80423,
	"./Logo_Lojas_Havan.png": 10923,
	"./bg-white-lock.png": 26324,
	"./blue-marker.png": 6214,
	"./dev1.png": 50444,
	"./entraga2.png": 17722,
	"./entrega1.png": 64301,
	"./entrega1.svg": 41754,
	"./entrega2.svg": 32011,
	"./entrega3.png": 9592,
	"./entrega3.svg": 71331,
	"./foto-moto.jpeg": 4654,
	"./hoteis.png": 39955,
	"./list.png": 56989,
	"./logo login.png": 72620,
	"./logo-default.png": 56506,
	"./logo-default1.png": 38308,
	"./logo-default2.png": 41719,
	"./logo-default2_old.png": 83368,
	"./logo-jokei.png": 98839,
	"./logo-jokei3.png": 69652,
	"./logo-portal.png": 46536,
	"./logo-portal2.png": 10049,
	"./logo-via7-3.png": 67640,
	"./logo-via7.png": 70015,
	"./passageiro.png": 37904,
	"./pedirTaxi.png": 28226,
	"./pessoa.jpeg": 10703,
	"./red-marker.png": 13098,
	"./remove.png": 38687,
	"./taxi.png": 27778,
	"./taxi.svg": 33466,
	"./user.png": 41198,
	"./vaide10iconeroxo.png": 69225,
	"./vaide10quadradoroxo.png": 93330,
	"./walmart.png": 21159
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96303;